import { isSelfHosted } from "@/helpers/self-hosted.helper"
import type { CommonDeployCommandProps } from "@/pages/DeploymentsPage/components/molecules/DeployCommand"
import {
  DEFAULT_VALUES,
  REGCRED_YAML_FILENAME
} from "@/pages/DeploymentsPage/const"
import { getKortexFilename } from "@/pages/DeploymentsPage/helpers"
import { getDeployCommandString } from "@/pages/DeploymentsPage/helpers/deployment-command"

import type { InitialValues } from "./helpers.types"

export const getDefaultValues = (initialValues?: InitialValues) => {
  const {
    environment = DEFAULT_VALUES.ENVIRONMENT,
    pullSecretName = DEFAULT_VALUES.SECRET_NAME,
    namespace = DEFAULT_VALUES.NAMESPACE,
    kodemHelmRepo = DEFAULT_VALUES.KODEM_HELM_REPO,
    kontigoUrl = DEFAULT_VALUES.KONTIGO_URL
  } = initialValues || {}

  return {
    deploymentKey: DEFAULT_VALUES.DEPLOYMENT_KEY,
    key: Date.now().toString(),
    namespace,
    pullSecretName,
    environment,
    kodemHelmRepo,
    kontigoUrl
  }
}

export const getLines = ({
  version,
  hasDeploymentFile = true
}: CommonDeployCommandProps) => ({
  kubectl_create_namespace: {
    name: "namespace",
    text: "kubectl create namespace",
    align: "space-between" as const,
    suffix: " &&"
  },
  apply_namespace: {
    name: "namespace",
    text: "kubectl apply --namespace",
    suffix: ` -f ${REGCRED_YAML_FILENAME} &&`,
    align: "space-between" as const
  },
  helm_upgrade: hasDeploymentFile
    ? {
        text: `helm upgrade --install kortex ${getKortexFilename(version)}`
      }
    : {
        name: "kodemHelmRepo",
        text: "helm upgrade --install kortex",
        suffix: "/kortex",
        align: "space-between" as const
      },
  namespace: {
    name: "namespace",
    text: "--namespace",
    align: "space-between" as const
  },
  environment: { name: "environment", text: "--set kortex.environment=" },
  deploymentKey: { name: "deploymentKey", text: "--set kortex.deploymentKey=" },
  pullSecretName: {
    name: "pullSecretName",
    text: "--set kortex.image.pullSecretName="
  },
  kontigoUrl: {
    name: "kontigoUrl",
    text: "--set kosmos.kontigoUrl="
  },
  autopilot: {
    text: "--set kortex.autopilot=true"
  },
  create_namespace: { text: "--create-namespace" }
})

export const getDeployCommand = (
  values: ReturnType<typeof getDefaultValues>,
  defaultValues: ReturnType<typeof getDefaultValues>,
  props: CommonDeployCommandProps
) => {
  const lines = getLines(props)
  const keys = [
    "kubectl_create_namespace",
    "apply_namespace",
    "helm_upgrade",
    "namespace",
    "environment",
    "deploymentKey",
    "pullSecretName",
    isSelfHosted() && "kontigoUrl",
    props.autopilot && "autopilot",
    "create_namespace"
  ].filter((key) => typeof key === "string")

  return getDeployCommandString(
    {
      lines,
      values,
      defaultValues
    },
    keys
  )
}
